import { render, staticRenderFns } from "./TipoVagaSelect.vue?vue&type=template&id=1b554c49&"
import script from "./TipoVagaSelect.vue?vue&type=script&lang=js&"
export * from "./TipoVagaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports